import {
  BaseballAttributeId,
  BaseballEventStatusId,
  BaseballIncidentId,
} from '@collector/sportsapi-client-legacy'

import {
  getBlockedPitchIncidentsMap,
  PitchIncidents,
  PitchIncidentsConfig,
} from '../../configuration'
import { pitchBlockedEventStatus } from './pitchBlockedEventStatus'

const pitchIncidents: PitchIncidents<BaseballIncidentId, BaseballAttributeId> =
  {
    gridClass: 'grid-cols-6',
    incidentButtonData: [
      [
        {
          incidentId: BaseballIncidentId.Run,
          class: 'col-span-3',
        },
        {
          incidentId: BaseballIncidentId.HomeRun,
          class: 'col-span-3',
        },
      ],
      [
        { incidentId: BaseballIncidentId.Hit, class: 'col-span-2' },
        { incidentId: BaseballIncidentId.Strikeout, class: 'col-span-2' },
        { incidentId: BaseballIncidentId.Out, class: 'col-span-2' },
      ],
      [
        { incidentId: BaseballIncidentId.Ball, class: 'col-span-2' },

        { incidentId: BaseballIncidentId.Strike, class: 'col-span-2' },
        {
          incidentId: BaseballIncidentId.SwingAndMiss,
          class: 'col-span-2',
        },
      ],
      [
        { incidentId: BaseballIncidentId.Walk, class: 'col-span-2' },
        {
          incidentId: BaseballIncidentId.Foul,
          class: 'col-span-2',
        },
        { incidentId: BaseballIncidentId.PickOffAttempt, class: 'col-span-2' },
      ],
      [
        {
          incidentId: BaseballIncidentId.InPlay,
          class: 'col-span-2',
        },
        {
          incidentId: BaseballIncidentId.InPlayOut,
          class: 'col-span-2',
        },
        {
          incidentId: BaseballIncidentId.InPlayRun,
          class: 'col-span-2',
        },
      ],
      [
        {
          incidentId: BaseballIncidentId.StolenBase,
          class: 'col-span-2',
        },
        {
          incidentId: BaseballIncidentId.WildPitch,
          class: 'col-span-2',
        },
        {
          incidentId: BaseballIncidentId.DoublePlay,
          class: 'col-span-2',
        },
      ],
      [
        {
          incidentId: BaseballIncidentId.CaughtStealing,
          class: 'col-span-2',
        },
        {
          incidentId: BaseballIncidentId.HitByPitch,
          class: 'col-span-2',
        },
        {
          incidentId: BaseballIncidentId.TriplePlay,
          class: 'col-span-2',
        },
      ],
      [
        {
          incidentId: BaseballIncidentId.Error,
          class: 'col-span-6',
        },
      ],
    ],
  }

const eventStatusToBlockedPitchIncidentsTextMap = new Map<
  BaseballEventStatusId,
  string
>([
  [BaseballEventStatusId.NotStarted, 'start 1st inning'],
  [BaseballEventStatusId.StartDelayed, 'start 1st inning'],
  [BaseballEventStatusId.BreakAfterFirstInning, 'start 2nd inning'],
  [BaseballEventStatusId.BreakAfterSecondInning, 'start 3rd inning'],
  [BaseballEventStatusId.BreakAfterThirdInning, 'start 4th inning'],
  [BaseballEventStatusId.BreakAfterFourthInning, 'start 5th inning'],
  [BaseballEventStatusId.BreakAfterFifthInning, 'start 6th inning'],
  [BaseballEventStatusId.BreakAfterSixthInning, 'start 7th inning'],
  [BaseballEventStatusId.BreakAfterSeventhInning, 'start 8th inning'],
  [BaseballEventStatusId.BreakAfterEighthInning, 'start 9th inning'],
  [BaseballEventStatusId.BreakAfterNinthInning, 'start 10th inning'],
  [BaseballEventStatusId.BreakAfterTenthInning, 'start 11th inning'],
  [BaseballEventStatusId.BreakAfterEleventhInning, 'start 12th inning'],
  [BaseballEventStatusId.BreakAfterTwelfthInning, 'start 13th inning'],
  [BaseballEventStatusId.BreakAfterThirteenthInning, 'start 14th inning'],
  [BaseballEventStatusId.BreakAfterFourteenthInning, 'start 15th inning'],
  [BaseballEventStatusId.BreakAfterFifteenthInning, 'start 16th inning'],
  [BaseballEventStatusId.BreakAfterSixteenthInning, 'start 17th inning'],
  [BaseballEventStatusId.BreakAfterSeventeenthInning, 'start 18th inning'],
  [BaseballEventStatusId.BreakAfterEighteenthInning, 'start 19th inning'],
  [BaseballEventStatusId.BreakAfterNineteenthInning, 'start 20th inning'],
  [BaseballEventStatusId.BreakAfterTwentiethInning, 'start 21st inning'],
  [BaseballEventStatusId.BreakAfterTwentyFirstInning, 'start 22nd inning'],
  [BaseballEventStatusId.BreakAfterTwentySecondInning, 'start 23rd inning'],
])

const blockedPitchIncidentsMap = getBlockedPitchIncidentsMap(
  pitchBlockedEventStatus,
  pitchIncidents.incidentButtonData,
)

export const pitchIncidentsConfig: PitchIncidentsConfig<
  BaseballEventStatusId,
  BaseballIncidentId,
  BaseballAttributeId
> = {
  pitchIncidents,
  blockedPitchIncidentsMap,
  eventStatusToBlockedPitchIncidentsTextMap,
}
